import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import PageHeader from '../../components/PageHeader';
import { Search, Filter, Plus, BookOpen, MoreVertical, X, Upload, GripVertical, Trash2, Check, Star, Edit } from 'lucide-react';
// Mock data
const mockCourses = [{
  id: 1,
  title: 'Zero Waste 101',
  access: 'Gratis',
  cost: 0,
  status: 'Pubblicato',
  updatedAt: '15/05/2025',
  lessons: 5
}, {
  id: 2,
  title: 'Compostaggio Domestico',
  access: 'Star',
  cost: 500,
  status: 'Pubblicato',
  updatedAt: '10/05/2025',
  lessons: 8
}, {
  id: 3,
  title: 'Mobilità Sostenibile',
  access: 'Gratis',
  cost: 0,
  status: 'Bozza',
  updatedAt: 'Oggi',
  lessons: 3
}];
const LMSCourses = () => {
  const location = useLocation();
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState<(typeof mockCourses)[0] | null>(null);
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [currentStep, setCurrentStep] = useState(1);
  // Check if we should open the drawer from navigation state
  useEffect(() => {
    if (location.state?.openDrawer) {
      setCurrentStep(1);
      setShowCreateDrawer(true);
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Pubblicato':
        return 'bg-green-100 text-green-800';
      case 'Bozza':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const steps = [{
    id: 1,
    name: 'Info'
  }, {
    id: 2,
    name: 'Lezioni'
  }, {
    id: 3,
    name: 'Quiz'
  }, {
    id: 4,
    name: 'Pubblicazione'
  }];
  const handleEdit = (course: (typeof mockCourses)[0]) => {
    setSelectedCourse(course);
    setShowEditDrawer(true);
    setOpenMenuId(null);
  };
  const handleDelete = (course: (typeof mockCourses)[0]) => {
    setSelectedCourse(course);
    setShowDeleteModal(true);
    setOpenMenuId(null);
  };
  const confirmDelete = () => {
    alert(`Corso "${selectedCourse?.title}" eliminato con successo!`);
    setShowDeleteModal(false);
    setSelectedCourse(null);
  };
  const handleCreateCourse = () => {
    setCurrentStep(1);
    setShowCreateDrawer(true);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2003">
      <div className="w-20 flex-shrink-0" data-id="element-2004">
        <Sidebar onCreateCourse={handleCreateCourse} data-id="element-2005" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2006">
        <Topbar data-id="element-2007" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2008">
          <PageHeader title="Corsi" subtitle="Crea e gestisci corsi, lezioni e quiz" primaryAction={{
          label: 'Crea corso',
          onClick: handleCreateCourse,
          icon: <Plus className="h-4 w-4 mr-2" data-id="element-2010" />
        }} data-id="element-2009" />

          {/* Filters */}
          <div className="flex gap-4 mb-6" data-id="element-2011">
            <div className="relative flex-1 max-w-md" data-id="element-2012">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-2013" />
              <input type="text" placeholder="Cerca corsi..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2014" />
            </div>
            <select className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2015">
              <option value="" data-id="element-2016">Tutti gli stati</option>
              <option value="Pubblicato" data-id="element-2017">Pubblicato</option>
              <option value="Bozza" data-id="element-2018">Bozza</option>
            </select>
            <select className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2019">
              <option value="" data-id="element-2020">Tutti gli accessi</option>
              <option value="Gratis" data-id="element-2021">Gratis</option>
              <option value="Star" data-id="element-2022">Star</option>
            </select>
          </div>

          {/* Table */}
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2023">
            <table className="w-full" data-id="element-2024">
              <thead className="bg-gray-50" data-id="element-2025">
                <tr data-id="element-2026">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2027">
                    Corso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2028">
                    Accesso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2029">
                    Costo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2030">
                    Lezioni
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2031">
                    Stato
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2032">
                    Ultimo agg.
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2033">
                    Azioni
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-2034">
                {mockCourses.map(course => <tr key={course.id} className="hover:bg-gray-50" data-id="element-2035">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2036">
                      <div className="flex items-center" data-id="element-2037">
                        <div className="h-10 w-10 rounded bg-gray-100 flex items-center justify-center mr-3" data-id="element-2038">
                          <BookOpen className="h-5 w-5 text-gray-500" data-id="element-2039" />
                        </div>
                        <span className="font-medium text-gray-900" data-id="element-2040">
                          {course.title}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2041">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${course.access === 'Gratis' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-2042">
                        {course.access === 'Gratis' ? 'Gratis' : 'Crediti Star'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2043">
                      {course.cost > 0 ? `${course.cost} Crediti Star` : '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2044">
                      {course.lessons}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-2045">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadge(course.status)}`} data-id="element-2046">
                        {course.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2047">
                      {course.updatedAt}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2048">
                      <div className="relative inline-block" data-id="element-2049">
                        <button onClick={e => {
                      e.stopPropagation();
                      setOpenMenuId(openMenuId === course.id ? null : course.id);
                    }} className="text-gray-400 hover:text-gray-600 p-1" data-id="element-2050">
                          <MoreVertical className="h-5 w-5" data-id="element-2051" />
                        </button>

                        {openMenuId === course.id && <>
                            <div className="fixed inset-0 z-10" onClick={() => setOpenMenuId(null)} data-id="element-2052" />
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20" data-id="element-2053">
                              <button onClick={() => handleEdit(course)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2 text-gray-700" data-id="element-2054">
                                <Edit className="h-4 w-4" data-id="element-2055" />
                                Modifica
                              </button>
                              <button onClick={() => handleDelete(course)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2 text-red-600 border-t border-gray-100" data-id="element-2056">
                                <Trash2 className="h-4 w-4" data-id="element-2057" />
                                Elimina
                              </button>
                            </div>
                          </>}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </main>
      </div>

      {/* Create Course Drawer */}
      {showCreateDrawer && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowCreateDrawer(false)} data-id="element-2058" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-2xl z-50 flex flex-col" data-id="element-2059">
            {/* Header */}
            <div className="p-6 border-b border-gray-200" data-id="element-2060">
              <div className="flex items-center justify-between mb-6" data-id="element-2061">
                <h2 className="text-xl font-bold" data-id="element-2062">Crea Nuovo Corso</h2>
                <button onClick={() => setShowCreateDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2063">
                  <X className="h-5 w-5" data-id="element-2064" />
                </button>
              </div>

              {/* Stepper */}
              <div className="flex items-center justify-between px-2" data-id="element-2065">
                {steps.map((step, index) => <div key={step.id} className="flex items-center" data-id="element-2066">
                    <div className={`flex items-center justify-center w-8 h-8 rounded-full border-2 ${currentStep >= step.id ? 'border-green-600 bg-green-600 text-white' : 'border-gray-300 text-gray-500'}`} data-id="element-2067">
                      {currentStep > step.id ? <Check className="h-4 w-4" data-id="element-2068" /> : <span className="text-xs font-semibold" data-id="element-2069">{step.id}</span>}
                    </div>
                    <span className={`ml-2 text-sm font-medium ${currentStep >= step.id ? 'text-green-600' : 'text-gray-500'}`} data-id="element-2070">
                      {step.name}
                    </span>
                    {index < steps.length - 1 && <div className={`w-12 h-0.5 mx-4 ${currentStep > step.id ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-2071" />}
                  </div>)}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-2072">
              {currentStep === 1 && <div className="space-y-6" data-id="element-2073">
                  <div data-id="element-2074">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2075">
                      Titolo Corso
                    </label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" placeholder="Es. Zero Waste 101" data-id="element-2076" />
                  </div>
                  <div data-id="element-2077">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2078">
                      Descrizione
                    </label>
                    <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" rows={4} data-id="element-2079" />
                  </div>
                  <div data-id="element-2080">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2081">
                      Cover Image
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-green-600 transition-colors cursor-pointer" data-id="element-2082">
                      <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" data-id="element-2083" />
                      <p className="text-sm text-gray-600" data-id="element-2084">
                        Clicca per caricare l'immagine
                      </p>
                    </div>
                  </div>
                  <div data-id="element-2085">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2086">
                      Accesso
                    </label>
                    <div className="flex gap-4" data-id="element-2087">
                      <label className="flex items-center gap-2" data-id="element-2088">
                        <input type="radio" name="access" className="text-green-600 focus:ring-green-600" defaultChecked data-id="element-2089" />
                        <span className="text-sm" data-id="element-2090">Gratis</span>
                      </label>
                      <label className="flex items-center gap-2" data-id="element-2091">
                        <input type="radio" name="access" className="text-green-600 focus:ring-green-600" data-id="element-2092" />
                        <Star className="h-4 w-4 text-amber-500" data-id="element-2093" />
                        <span className="text-sm" data-id="element-2094">
                          Sblocca con Crediti Star
                        </span>
                      </label>
                    </div>
                  </div>
                </div>}

              {currentStep === 2 && <div className="space-y-4" data-id="element-2095">
                  <div className="flex items-center justify-between mb-4" data-id="element-2096">
                    <h3 className="font-medium text-gray-900" data-id="element-2097">Lista Lezioni</h3>
                    <button className="text-sm text-green-600 font-medium hover:underline flex items-center gap-1" data-id="element-2098">
                      <Plus className="h-4 w-4" data-id="element-2099" /> Aggiungi lezione
                    </button>
                  </div>
                  {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-2100">
                      <GripVertical className="h-5 w-5 text-gray-400 cursor-move" data-id="element-2101" />
                      <div className="flex-1" data-id="element-2102">
                        <p className="text-sm font-medium text-gray-900" data-id="element-2103">
                          Lezione {i}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2104">Video • 5 min</p>
                      </div>
                      <button className="text-gray-400 hover:text-red-500" data-id="element-2105">
                        <Trash2 className="h-4 w-4" data-id="element-2106" />
                      </button>
                    </div>)}
                </div>}

              {currentStep === 3 && <div className="space-y-6" data-id="element-2107">
                  <div className="flex items-center justify-between mb-4" data-id="element-2108">
                    <h3 className="font-medium text-gray-900" data-id="element-2109">Domande Quiz</h3>
                    <button className="text-sm text-green-600 font-medium hover:underline flex items-center gap-1" data-id="element-2110">
                      <Plus className="h-4 w-4" data-id="element-2111" /> Aggiungi domanda
                    </button>
                  </div>
                  <div className="p-4 border border-gray-200 rounded-lg" data-id="element-2112">
                    <div className="mb-3" data-id="element-2113">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2114">
                        Domanda 1
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="Testo della domanda..." data-id="element-2115" />
                    </div>
                    <div className="space-y-2" data-id="element-2116">
                      <div className="flex items-center gap-2" data-id="element-2117">
                        <input type="radio" name="q1" disabled data-id="element-2118" />
                        <input type="text" className="flex-1 px-3 py-1 border border-gray-300 rounded text-sm" placeholder="Opzione A" data-id="element-2119" />
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2120">
                        <input type="radio" name="q1" disabled data-id="element-2121" />
                        <input type="text" className="flex-1 px-3 py-1 border border-gray-300 rounded text-sm" placeholder="Opzione B" data-id="element-2122" />
                      </div>
                    </div>
                  </div>
                </div>}

              {currentStep === 4 && <div className="text-center py-8" data-id="element-2123">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2124">
                    <Check className="h-8 w-8 text-green-600" data-id="element-2125" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2126">
                    Tutto pronto!
                  </h3>
                  <p className="text-gray-500 mb-6" data-id="element-2127">
                    Il corso è completo e pronto per essere pubblicato.
                  </p>
                  <div className="bg-gray-50 rounded-lg p-4 text-left max-w-sm mx-auto" data-id="element-2128">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-2129">
                      <span className="font-medium" data-id="element-2130">Titolo:</span> Zero Waste
                      101
                    </p>
                    <p className="text-sm text-gray-600 mb-1" data-id="element-2131">
                      <span className="font-medium" data-id="element-2132">Lezioni:</span> 3
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-2133">
                      <span className="font-medium" data-id="element-2134">Quiz:</span> 1 (5 domande)
                    </p>
                  </div>
                </div>}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-gray-200 flex justify-between" data-id="element-2135">
              {currentStep > 1 ? <button onClick={() => setCurrentStep(currentStep - 1)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2136">
                  Indietro
                </button> : <button onClick={() => setShowCreateDrawer(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2137">
                  Annulla
                </button>}

              {currentStep < 4 ? <button onClick={() => setCurrentStep(currentStep + 1)} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2138">
                  Avanti
                </button> : <button onClick={() => {
            alert('Corso pubblicato!');
            setShowCreateDrawer(false);
          }} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2139">
                  Pubblica Corso
                </button>}
            </div>
          </div>
        </>}

      {/* Edit Course Drawer */}
      {showEditDrawer && selectedCourse && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowEditDrawer(false)} data-id="element-2140" />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-2141">
            <div className="p-6" data-id="element-2142">
              <div className="flex items-center justify-between mb-6" data-id="element-2143">
                <h2 className="text-xl font-bold" data-id="element-2144">Modifica Corso</h2>
                <button onClick={() => setShowEditDrawer(false)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-2145">
                  <X className="h-5 w-5" data-id="element-2146" />
                </button>
              </div>

              <div className="space-y-6" data-id="element-2147">
                <div data-id="element-2148">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2149">
                    Titolo Corso
                  </label>
                  <input type="text" defaultValue={selectedCourse.title} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2150" />
                </div>
                <div data-id="element-2151">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2152">
                    Descrizione
                  </label>
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" rows={4} defaultValue="Descrizione del corso..." data-id="element-2153" />
                </div>
                <div data-id="element-2154">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2155">
                    Stato
                  </label>
                  <select defaultValue={selectedCourse.status} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-2156">
                    <option value="Bozza" data-id="element-2157">Bozza</option>
                    <option value="Pubblicato" data-id="element-2158">Pubblicato</option>
                  </select>
                </div>
              </div>

              <div className="flex gap-3 mt-8 pt-6 border-t border-gray-200" data-id="element-2159">
                <button onClick={() => setShowEditDrawer(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2160">
                  Annulla
                </button>
                <button onClick={() => {
              alert('Corso aggiornato!');
              setShowEditDrawer(false);
            }} className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-2161">
                  Salva modifiche
                </button>
              </div>
            </div>
          </div>
        </>}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedCourse && <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setShowDeleteModal(false)} data-id="element-2162" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4" data-id="element-2163">
            <div className="bg-white rounded-lg max-w-md w-full p-6" data-id="element-2164">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2165">
                Elimina Corso
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2166">
                Sei sicuro di voler eliminare il corso "{selectedCourse.title}"?
                Questa azione non può essere annullata.
              </p>
              <div className="flex gap-3" data-id="element-2167">
                <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-2168">
                  Annulla
                </button>
                <button onClick={confirmDelete} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700" data-id="element-2169">
                  Elimina
                </button>
              </div>
            </div>
          </div>
        </>}
    </div>;
};
export default LMSCourses;